import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'

export class KpiSaleOrderService extends BaseService {

  static async kpiGetList(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.get-list'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiConfirm(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.confirm-kpi'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiDetail(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.detail'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiItemCancel(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.cancel-kpi-item'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiItemChangeMonth(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.change-month-kpi'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiFilterItem(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.filter-kpi-item'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiCreate(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-process.create-kpi'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiPushRequestKpi(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-process.push-request-kpi'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiPushRequestKpi(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-process.push-request-kpi'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiCalculateOrder(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-process.calculate-order-kpi'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async kpiItemDetail(body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.perf.kpi-order.kpi-item.detail'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}